import React, { useState } from "react";
import PageContainer from "../../components/common/PageContainer";
import BaseTable from "../../components/table/BaseTable";
import AgentCard from "../../components/agents/AgentCard";

import useIsMobile from "../../hooks/useIsMobile";

import { Link } from "react-router-dom";

import { formatDateDDMMYYYY } from "../../hooks/commonHooks";
import {
  useAgentsQuery,
  useToggleAgentStatusMutation,
} from "../../queries/agents/useAgentsQuery";

import Switch from "../../components/ui/Switch";
import ConfirmModal from "../../components/ui/ConfirmModal";
import Loader from "../../components/ui/Loader/Loader";

export default function Agents() {
  const { data: agents, isLoading, isSuccess } = useAgentsQuery();
  const { mutate: toggleStatus, isPending: isTogglePending } =
    useToggleAgentStatusMutation();
  const [confirmAgentId, setConfirmAgentId] = useState(null);

  const isMobile = useIsMobile();

  if (isLoading || isTogglePending) return <Loader />;



  const handleToggleStatus = (id) => {
    setConfirmAgentId(id);
  };

  const handleConfirmToggle = () => {
    if (!confirmAgentId) return;
    toggleStatus({ agentId: confirmAgentId });
    setConfirmAgentId(null);
  };

  const columns = [
    {
      title: "Agent Name",
      dataIndex: "name",
      render: (name, row) => (
        <div className="d-flex align-center">
          <Link to={`/agents/${row.id}`}>
            <span className="fw-medium text-primary">{name}</span>
          </Link>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
    },

    {
      title: "Industry",
      dataIndex: "industry",
    },
    {
      title: "Leads",
      dataIndex: "leads_count",
    },
    {
      title: "Properties",
      dataIndex: "properties_count",
    },
    {
      title: "Status",
      dataIndex: "is_active",
      render: (is_active, row) => (
        <Switch
          checked={is_active}
          onChange={() => handleToggleStatus(row.id)}
        />
      ),
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      className: "text-muted",
      render: (value) => formatDateDDMMYYYY(value),
    },
  ];

  return (
    <PageContainer>
      <div className="d-flex justify-between align-center mb-3">
        <h2 className="text-primary m-0">Agents Directory</h2>
      </div>

      {isMobile ? (
        <div className="grid-auto-fit">
          {agents.map((agent) => (
            <AgentCard
              key={agent.id}
              agent={agent}
              toggleStatus={handleToggleStatus}
            />
          ))}
        </div>
      ) : (
        <BaseTable columns={columns} data={agents} rowKey="id" />
      )}


      <ConfirmModal
        isOpen={!!confirmAgentId}
        title="Change Agent Status"
        message="Are you sure you want to toggle this agent's active status?"
        confirmLabel="Yes, change status"
        cancelLabel="Cancel"
        onConfirm={handleConfirmToggle}
        onCancel={() => setConfirmAgentId(null)}
        isLoading={isTogglePending}
        confirmVariant="primary"
      />
    </PageContainer>
  );
}
